<!--FastBI产品-->
<template>
  <div class="upgradeDialog">
    <el-dialog
      :before-close="restForm"
      :title="'试用延期'"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="560px"
    >
      <el-form :model="extensionData" ref="form" :rules="formRules">
        <el-form-item :label-width="formLabelWidth" :label="firstFormName">
          <el-input v-model="extensionData['code']" disabled></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="当前有效期至">
          <el-input v-model="extensionData['expire_time']" disabled></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="调整有效期至" prop="new_expire_time">
          <!-- value-format="yyyy-MM-dd hh:mm:ss" -->
          <el-date-picker
            v-model="extensionData.new_expire_time"
            type="date"
            align="right"
            size="small"
            value-format="yyyy-MM-dd hh:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form', (visible = false))">取 消</el-button>
        <el-button @click="extensionSubmit" type="primary" :disabled="!extensionData.new_expire_time">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getXZEditions } from '@/api/auth';
import { getVersionOption, version } from '../../xzReport/utils';
import { MessageBox, Message } from 'element-ui';
import { trialExtension, trialExtensionModele, trialExtensionSuit, xz_trialExtension } from '@/api/xz_product';
export default {
  data() {
    return {
      visible: false,
      formLabelWidth: '110px',
      formRules: {
        new_expire_time: [
          {
            required: true,
            message: '时间不能为空',
            trigger: 'blur',
          },
        ],
      },
      extensionData: {
        code: '',
        expire_time: '',
        new_expire_time: '',
        id: '',
      },
      module: '',
      firstFormName: '授权码',
    };
  },
  mounted() {},
  methods: {
    initData(data, _modules) {
      console.log(data, _modules, '_modules_modules');
      this.module = _modules;

      const { expire_time, code, auth_code, id, domain } = data;
      this.extensionData = {
        code: auth_code || code,
        expire_time,
        new_expire_time: '',
        id,
      };
      if (this.module === 'xz') {
        this.extensionData.code = domain;
        this.firstFormName = '授权IP/域名';
      }
    },
    restForm(done) {
      this.cancel();
      done();
    },
    show() {
      this.visible = true;
    },
    cancel(formName, close) {
      this.extensionData = {
        code: '',
        expire_time: '',
        new_expire_time: '',
        id: '',
      };
    },
    async extensionSubmit() {
      const { id, new_expire_time } = this.extensionData;
      const data = { expire_time: new_expire_time };
      try {
        let delayQuest = null;
        switch (this.module) {
          case 'list':
            delayQuest = trialExtension;
            break;
          case 'suit':
            delayQuest = trialExtensionSuit;
            break;
          case 'xz':
            delayQuest = xz_trialExtension;
            break;
          default:
            delayQuest = trialExtensionModele;
            break;
        }
        const res = await delayQuest({ id, data });
        if (res) {
          Message({
            message: `有效期成功调整为${new_expire_time}`,
            type: 'success',
            duration: 3 * 1000,
          });
          this.visible = false;
          /* 更新表格数据 */
          this.$parent.restSearch(this.module);
        }
      } catch (error) {
        console.warn(error);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/product/dialog/extensionDialog.vue